import { ActionTypes } from "../constants/action-types"

const initialState = {
    tutorialTopicById: []
}

const FetchTutorialTopicById = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.FETCH_TUTORIAL_TOPIC_BY_ID : return {...state, 
            tutorialTopicById: payload}           
        default: return state;
    }
    
}


export default FetchTutorialTopicById;